import React from 'react';
import { StarIcon } from 'icons';
import Link from 'next/link';

import { ICourse, SaveCourse } from 'modules/courses';
import { globalConst } from 'modules/global';

import Avatar from './avatar';

interface IProps {
  course?: ICourse;
}

const FirstSection: React.FC<IProps> = ({ course }) => (
  <div className="relative h-full w-full rounded-xl bg-white p-4">
    <Link href={`${globalConst.pageNames.TEACHER}/${course?.teacher?.slug}`} className="group inline-flex">
      <Avatar
        specialty={course?.teacher?.user_name}
        createdAt={course?.created_at}
        userImage={course?.teacher?.image?.small}
        userName={course?.teacher?.full_name}
      />
    </Link>
    <div className="mt-4 flex items-start justify-between">
      <p className="font-medium">{course?.name}</p>
      <div className="text-md flex h-5 items-center gap-1 rounded-br-lg bg-white px-1 pl-3">
        <span>
          <StarIcon color="text-yellow-300" />
        </span>
        {course?.rating}
      </div>
    </div>

    <div className="absolute right-4 top-4 cursor-pointer">
      <SaveCourse courseId={course?.id as number} iconClass="size-5" isSaved={course?.is_saved as boolean} />
    </div>
    {/* KERAK BO"LADI: 
    <div className="mt-4 hidden grid-cols-3 gap-3 lg:grid">
        <Statistics count={course?.students_count || 0} label={t('oquvchilar_soni')} icon={<DollarCircleIcon />} />
        <Statistics
          count={course?.course_students_count || 0}
          label={t('sotib_olganlar')}
          icon={<DollarCircleIcon />}
        />
        <Statistics
          count={course?.solved_tests_count || 0}
          label={t('yechilgan_testlar_soni')}
          icon={<DollarCircleIcon />}
        />
      </div> */}
  </div>
);

export default FirstSection;
